// extracted by mini-css-extract-plugin
export var header = "_sg-1";
export var maskBottom = "_sg-6";
export var maskMiddle = "_sg-7";
export var maskTop = "_sg-5";
export var root = "_sg-0";
export var scrollDownButton = "_sg-3";
export var scrollDownButtonHidden = "_sg-4";
export var viewport = "_sg-2";